import VistaprintAuth from '@vp/auth';
export default function init(options) {
    return new Promise(function (resolve, reject) {
        VistaprintAuth.init(options, function (identity) {
            resolve(identity);
        }, function (error) {
            reject(error);
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5pdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbml0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sY0FBYyxNQUFNLFVBQVUsQ0FBQztBQUV0QyxNQUFNLENBQUMsT0FBTyxVQUFVLElBQUksQ0FBQyxPQUFZO0lBQ3JDLE9BQU8sSUFBSSxPQUFPLENBQU0sVUFBQyxPQUFZLEVBQUUsTUFBVztRQUM5QyxjQUFjLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxVQUFDLFFBQWE7WUFDdkMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3RCLENBQUMsRUFBRSxVQUFDLEtBQVU7WUFDVixNQUFNLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDbEIsQ0FBQyxDQUFDLENBQUM7SUFDUCxDQUFDLENBQUMsQ0FBQztBQUNQLENBQUMifQ==